import React from "react";
import bg from "../../assets/about.jpg";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { addToCart } from "../../actions/storeActions";
import { useDispatch } from "react-redux";
const ProductDetail = ({
  data: {
    discount,
    price,
    reservation,
    name,
    type,
    category,
    pieces,
    _id,
    points,
    thumbnail,
  },
  address,
  idx,
  setMessage,
}) => {
  const dispatch = useDispatch();

  const discountedPrice =
    price - price * (discount < 100 ? discount : discount / 100);
  const handleAddToCart = async () => {
    dispatch({
      type: "SET_CANVAS",
      payload: { openCanvas: true, message: "Attempting to add..." },
    });
    const data = {
      cartItems: {
        price: discount > 0 ? discountedPrice : price,
        name,
        _id,
        points,
        thumbnail: thumbnail ? thumbnail : bg,
      },
    };
    const { param, found } = await addToCart(data);

    if (param === "success" && found === false) {
      dispatch({
        type: "SET_MESSAGE",
        payload: {
          message: "Added to cart successfully!",
          canvasMessage: null,
        },
      });
      dispatch({ type: "ADD_TO_CART_BTN", payload: idx });
    } else if (param === "success" && found === true) {
      dispatch({
        type: "SET_MESSAGE",
        payload: { message: "Item is already added!", canvasMessage: null },
      });
      dispatch({ type: "ADD_TO_CART_BTN", payload: idx });
    } else if (param === "No token found" || param === "invalidToken") {
      dispatch({ type: "SET_MESSAGE", payload: "Please login first!" });
    } else {
      dispatch({
        type: "SET_MESSAGE",
        payload: {
          message: "Added to cart successfully!",
          canvasMessage: null,
        },
      });
      dispatch({ type: "ADD_TO_CART_BTN", payload: idx });
    }
  };
  return (
    <div className="product_detail">
      <div className={"product_thumbnail"}>
        <div className={pieces <= 0 ? "out_stock" : ""}>
          {" "}
          {pieces <= 0 && "Out of stock"}
        </div>
        <img
          loading="lazy"
          src={
            thumbnail
              ? `https://drive.google.com/thumbnail?id=${thumbnail}`
              : bg
          }
          alt=""
        />
      </div>
      <div className="product_text_detail">
        <div className="product_price_container">
          {discount > 0 && (
            <p className="discounted product_discounted">₱{discountedPrice}</p>
          )}
          <div className="price_and_discount">
            <span
              className={
                discount > 0 ? "product_original" : "product_discounted"
              }
            >
              ₱{price}
            </span>
            {discount > 0 && (
              <span>
                {"    -"}
                {discount < 100 ? discount * 100 : discount}%
              </span>
            )}
          </div>
        </div>
        <div>
          <span className="product_name"> {name}</span>
          <span className="product_type">{type}</span>
        </div>
        {reservation && <p className="reserve">open for reservation</p>}
        <p>{pieces} pcs left</p>
        <button
          className="product_cart_btn"
          disabled={pieces <= 0}
          onClick={() => {
            handleAddToCart();
          }}
        >
          {pieces > 0 ? (
            <span>
              <AiOutlineShoppingCart /> ADD TO CART
            </span>
          ) : (
            "Out of stock"
          )}
        </button>
      </div>
    </div>
  );
};

export default ProductDetail;
